import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useMarketerSectionsAlertTypeMessageAndTitle } from './InpageSectionsHooks';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import InpageDraggableSection from './InpageDraggableSection';
import InpageNoSavedSectionsMessage from './InpageNoSavedSectionsMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getSavedSections, getMarketerSectionsLimitInfo, getMarketerSectionsLimit, getMarketerSectionsCount } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import InpageSectionAccordion, { TitleWrapper } from './InpageSectionAccordion';
import { PATAGONIA_ADD_PANEL_SUB_CATEGORIES } from 'ContentEditorUI/constants/Sidebar';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function InpageSavedSectionsContainer({
  onDragStart,
  onDragEnd,
  themePath
}) {
  const savedSections = useSelector(getSavedSections);
  // When embeds end up in saved sections - but through the other service this will need to be refactored
  const marketerSectionsCount = useSelector(getMarketerSectionsCount);
  const marketerSectionsLimit = useSelector(getMarketerSectionsLimit);
  const hasMarketerSections = !!savedSections && savedSections.length > 0;

  /* TODO type marketerSectionsLimitInfo when migrating templateInfoSelectors */
  const marketerSectionsLimitInfo = useSelector(getMarketerSectionsLimitInfo);
  const [alertType, alertMessage, alertTitle] = useMarketerSectionsAlertTypeMessageAndTitle(marketerSectionsLimitInfo);
  const shouldShowMarketerSectionsLimitAlert = alertType !== null;
  return /*#__PURE__*/_jsxs(InpageSectionAccordion, {
    title: /*#__PURE__*/_jsx(TitleWrapper, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "addSectionPanel.customSections.savedSections",
        options: {
          count: marketerSectionsCount,
          limit: marketerSectionsLimit
        }
      })
    }),
    type: PATAGONIA_ADD_PANEL_SUB_CATEGORIES.SECTIONS.SAVED,
    children: [!hasMarketerSections && /*#__PURE__*/_jsx(InpageNoSavedSectionsMessage, {}), hasMarketerSections && /*#__PURE__*/_jsxs(_Fragment, {
      children: [shouldShowMarketerSectionsLimitAlert && /*#__PURE__*/_jsx(Alert, {
        type: alertType,
        titleText: alertTitle,
        marginBlockEnd: "400",
        marginBlockStart: "300",
        children: alertMessage
      }), /*#__PURE__*/_jsx(CardGrid, {
        columns: 1,
        gutterSize: 10,
        marginBlockStart: "400",
        children: savedSections.map(section => /*#__PURE__*/_jsx(InpageDraggableSection, {
          section: section,
          onDragStart: onDragStart,
          onDragEnd: onDragEnd,
          isDraggable: !marketerSectionsLimitInfo.isOverLimit,
          themePath: themePath
        }, section.id))
      })]
    })]
  });
}
InpageSavedSectionsContainer.propTypes = {
  onDragStart: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired
};